<template>
  <div class="wrap" id="wrap">
    <header class="agent-box">
      <div class="main">
        <div class="logo-box">
          <span
            class="broke-logo"
            :style="{
              backgroundImage: 'url(' + img_url + agentData.brokeLogo + ')'
            }"
          ></span>
          <span>{{ agentData.licenceNo }}</span>
        </div>
        <div class="agent-info">
          <span
            class="agent-headshot"
            :style="{
              backgroundImage: 'url(' + img_url + agentData.logo + ')'
            }"
          ></span>
          <span class="agent-name">{{ agentData.agentName }}</span>
          <p
            class="agent-mobile"
            :class="{ agentHuttons: agentData.brokeName === 'Huttons' }"
          >
            <span class="mobile-img"></span>
            <a :href="`tel:${agentData.mobile}`">{{ agentData.mobile }}</a>
          </p>
          <p
            class="agent-mobile"
            :class="{ agentHuttons: agentData.brokeName === 'Huttons' }"
          >
            <span class="email-img"></span>
            <a :href="`mailto:${agentData.email}`">Email</a>
          </p>
          <p
            class="agent-mobile"
            :class="{ agentHuttons: agentData.brokeName === 'Huttons' }"
          >
            <span class="whatsapp-img"></span>
            <a target="_blank" :href="`https://wa.me/${whatsapp}`">WhatsApp</a>
          </p>
        </div>
      </div>
    </header>

    <nav class="nav-wrap">
      <div class="main">
        <ul class="menu-list">
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Description' }"
            v-if="detailsInfo.description"
            @click="toScroll('Description')"
          >
            <span>Description</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Gallery' }"
            v-if="MediaData.img && MediaData.img.length > 0"
            @click="toScroll('Gallery')"
          >
            <span>Gallery</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'SiteFloorPlan' }"
            @click="toScroll('SiteFloorPlan')"
          >
            <span>Site and Floor Plan</span>
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Elevation' }"
            @click="toScroll('Elevation')"
          >
            Elevation chart
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Facilities' }"
            v-if="detailsInfo.nearbyAmenities"
            @click="toScroll('Facilities')"
          >
            Nearby Amenities
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Calculator' }"
            v-if="calcUrl"
            @click="toScroll('Calculator')"
          >
            Calculator
          </li>
          <li
            class="menu-item"
            :class="{ active: navgatorIndex == 'Register' }"
            @click="toScroll('Register')"
          >
            Register
          </li>
        </ul>
      </div>
    </nav>
    <div
      v-if="detailsInfo.mainImage"
      class="banner"
      :style="{
        backgroundImage: 'url(' + img_url + detailsInfo.mainImage + ')'
      }"
    >
      <p class="project-name">{{ detailsInfo.projectName }}</p>
    </div>
    <div v-else class="banner" :style="{ backgroundImage: backgroundImage }">
      <p class="project-name">{{ detailsInfo.projectName }}</p>
    </div>
    <article class="content-box">
      <div class="main">
        <div class="client-box">
          <!-- <h1 class="client-title">Dear Valued Client</h1>
          <p class="client-content">I am elated to share with you on this potential development {{detailsInfo.projectName}} with you. Please do not hesitate to enquire more or arrange an appointment with me. I look forward to hear from you soon, thank you!</p> -->
          <h2 class="project-name">Project Information</h2>
          <!-- <van-tag
            v-if="detailsInfo.projectStatus == 'By BUC'"
            type="warning"
          >{{detailsInfo.projectStatus}}</van-tag>
          <van-tag
            v-if="detailsInfo.projectStatus == 'Completed'"
            type="success"
          >{{detailsInfo.projectStatus}}</van-tag>
          <van-tag v-if="detailsInfo.projectStatus == 'TOP soon'">{{detailsInfo.projectStatus}}</van-tag> -->
          <van-row>
            <van-col span="4">Developer</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.developer
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Type</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.projectType
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Total</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.unitsNum
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">EXP Top</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.expTop
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Address</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.streetAddress
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Location</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.location
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Country</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.country
            }}</van-col>
          </van-row>
          <van-row>
            <van-col span="4">Tenure</van-col>
            <van-col class="van-ellipsis" span="16">{{
              detailsInfo.tenure
            }}</van-col>
          </van-row>
        </div>

        <div
          class="description-box"
          id="Description"
          v-if="detailsInfo.description"
        >
          <h1>DESCRIPTION</h1>
          <div class="descriptionDiv" v-html="detailsInfo.description"></div>
        </div>

        <div
          class="gallery-box"
          id="Gallery"
          v-if="MediaData.img && MediaData.img.length > 0"
        >
          <h1>Gallery</h1>
          <div class="img-box">
            <!-- <p class="img" v-for="(item, index) in MediaData.img" :key="index" :style="{backgroundImage: `url(${img_url + item.url})`}"  :preview="index" :preview-text="item.title"  :class="{'margin-left': index>=1}"></p> -->
            <el-image
              v-for="(item, index) in MediaData.img"
              :key="index"
              :src="img_url + item.url"
              :preview-src-list="imgList"
              :class="{ 'margin-left': index >= 1 }"
            >
              <div slot="error">
                Load Fail
              </div>
            </el-image>
          </div>
        </div>

        <div
          class="virtual-wrap"
          v-if="MediaData.ivt && MediaData.ivt.length > 0"
        >
          <h1>Virtual Tour</h1>
          <div class="virtual-box">
            <div
              class="img-box"
              v-for="(item, index) in MediaData.ivt"
              :key="index"
              :class="{
                'margin-top': index >= 2,
                'margin-top-ipad': index >= 1
              }"
            >
              <img :src="img_url + item.url" alt="" />
              <div class="LinkBtn" @click="goFileLink(item)">
                <span class="iconSpn"></span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="virtual-wrap"
          v-if="MediaData.video && MediaData.video.length > 0"
        >
          <h1>Video</h1>
          <div class="virtual-box">
            <div
              class="img-box"
              v-for="(item, index) in MediaData.video"
              :key="index"
              :class="{
                'margin-top': index >= 2,
                'margin-top-ipad': index >= 1
              }"
            >
              <img :src="img_url + item.logoUrl" alt="" />
              <div class="LinkBtn" @click="gotoVideo(item)">
                <span class="VideoBtn"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="site-plan-box" id="SiteFloorPlan">
          <h1>Site and Floor Plan</h1>
          <div class="img-box">
            <el-image
              v-for="(item, index) in sitePlanImg"
              :key="index"
              :src="img_url + item.img"
              :preview-src-list="sitePlanImgList"
              :class="{
                'margin-top': index >= 2,
                'margin-top-ipad': index >= 1
              }"
            >
              <div slot="error" class="el-error">
                Load Fail
              </div>
            </el-image>
            <!-- <img v-for="(item, index) in sitePlanImg" :src="img_url + item.img" alt="" :class="{'margin-top': index>=2}"> -->
          </div>
        </div>

        <div class="elevation-chart-box" id="Elevation">
          <h1>Elevation chart</h1>
          <div class="img-box">
            <el-image
              v-for="(item, index) in ElevationChartImg"
              :key="index"
              :src="img_url + item.img"
              :preview-src-list="ElevationChartImgList"
              :class="{
                'margin-top': index >= 1,
                'margin-top-ipad': index >= 1
              }"
            >
              <div slot="error" class="el-error">
                Load Fail
              </div>
            </el-image>
            <!-- <img v-for="(item, index) in ElevationChartImg" :src="img_url + item.img" alt="" :class="{'margin-top': index>=2}"> -->
          </div>
        </div>

        <div
          class="facilities-box"
          id="Facilities"
          v-if="detailsInfo.facilitiesMap"
        >
          <h1>Nearby Amenities</h1>
          <div
            class="nearby-list-box"
            v-for="(item, index) in nearbyList"
            :key="index"
          >
            <p class="nearby-list-name">
              <span class="nearby-list-mark"></span
              ><span class="nearby-list-text">{{
                item.type === "subway_station"
                  ? "Mrt Station"
                  : $capitalizeAndRemoveUnderscore(item.type)
              }}</span>
            </p>
            <ul class="nearby-list">
              <li
                class="nearby-item"
                v-for="(sitem, sindex) of item.value"
                :key="sindex"
              >
                <span>{{ sitem.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="facilities-box"
          id="Facilities"
          v-else-if="detailsInfo.nearbyAmenities"
        >
          <h1>Nearby Amenities</h1>
          <div
            class="nearby-content"
            v-html="detailsInfo.nearbyAmenities"
          ></div>
        </div>

        <div class="floor-plans-box">
          <h1>Floor Plan</h1>
          <div class="floor-content">
            <div class="popup-top">
              <p class="popup-selected" @click="showDropdown()">
                <span class="popup-text">{{ activeText }}</span>
                <van-icon name="arrow-down" v-show="!active" />
                <van-icon v-show="active" name="arrow-up" />
              </p>
              <p class="total">Total:{{ unitData.length }}</p>
            </div>
            <div class="dropdown-mark" v-show="active">
              <div class="dropdown-box">
                <p
                  v-for="(item, index) in UnitTypeData"
                  :key="index"
                  :class="{ active: item.text == activeText }"
                  @click="selectUnitType(item.text)"
                >
                  {{ item.text }}
                </p>
              </div>
            </div>
            <div class="plans-box">
              <el-image
                v-for="(item, index) in unitData"
                :key="index"
                :src="img_url + item.img"
                :preview-src-list="unitDataList"
                :class="{
                  'margin-top': index >= 2,
                  'margin-top-ipad': index >= 1
                }"
              >
                <div slot="error">
                  Load Fail
                </div>
              </el-image>
              <!-- <img v-for="(item, index) in unitData" :key="index" :src="img_url + item.img" alt="" :class="{'margin-top': index>=2}"> -->
            </div>
          </div>
        </div>

        <div class="available-box">
          <h1>Available Units</h1>
          <div class="table-wrap">
            <table class="table-box">
              <thead>
                <tr>
                  <th class="align-left">Type</th>
                  <th class="align-center">
                    Size({{ projectSet && projectSet.areaUnit1 }})
                  </th>
                  <th class="align-center">Floor Price</th>
                  <th class="align-right">#Units</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in statisticsList" :key="index">
                  <td class="align-left border-right">{{ item.type }}</td>
                  <td class="align-center border-right">
                    {{ item.minArea }}-{{ item.maxArea }}
                  </td>
                  <td class="align-center border-right">
                    {{ item.min_price }}
                  </td>
                  <td class="align-right">{{ item.unitNum }}</td>
                </tr>
              </tbody>
            </table>
            <p class="callMe">Contact me for more information</p>
          </div>
        </div>

        <div class="avenir-box" v-if="agentData.brokeName !== 'Huttons'">
          <h1>{{ detailsInfo.projectName }}</h1>
          <div class="map-box">
            <div class="map-info">
              <p>District：{{ detailsInfo.location }}</p>
              <p>
                Address：{{ detailsInfo.streetAddress }},{{ detailsInfo.country
                }}{{ detailsInfo.postalCode }}
              </p>
              <p>
                Gallery Address：<a
                  href=":javascript"
                  target="_blank"
                  @click="toLink"
                  >{{ detailsInfo.galleryLocation }}</a
                >
              </p>
            </div>
            <div v-if="detailsInfo.snapshotLogo" class="img-box">
              <img :src="img_url + detailsInfo.snapshotLogo" alt="" />
            </div>
            <!-- <div id="avenir-map"></div> -->
          </div>
        </div>
        <!--  v-if="calcUrl" -->
        <div class="calculator-wrap" v-if="calcUrl" id="Calculator">
          <h1>Calculator</h1>
          <div class="calculator-box">
            <el-button @click="gotoCalculate()">Calculate</el-button>
          </div>
        </div>

        <div class="showflat-box" v-if="agentData.brokeName !== 'Huttons'">
          <h1>View Showflat</h1>
          <div class="showflat-bontent">
            <p>
              Register Or Call Our Sales Hotline
              <span class="phone">{{ agentData.mobile }}</span> for many precise
              information & Priority accessibility for hassle-free experiences.
            </p>
            <!-- <p>Enjoy Direct Developer Discount & Non-Obligation Free Consultation！</p> -->
            <p>
              Due to the current situation, it is essential that you contact
              <span class="phone">{{ agentData.mobile }}</span> to confirm your
              showflat appointment.
            </p>
            <p>
              Registered Parties will be eligible for our Immediate Developer
              Appointed Marketing Pricing in addition to live updates of the
              advancement. Submit your Expression of Interest online and be a
              proud owner at the {{ detailsInfo.projectName }}！
            </p>
          </div>
        </div>

        <div class="register-box" id="Register">
          <h1>Register your interest</h1>
          <div class="form-box">
            <p>
              Book an appointment to view {{ detailsInfo.projectName }} show
              flat or send us an inquiry.We will get back to you as soon as
              possible.
            </p>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              label-position="top"
            >
              <el-row>
                <el-form-item label="Name" prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="Enter your name"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    type="number"
                    placeholder="Enter your mobile number"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="Email" prop="email">
                  <el-input
                    v-model="ruleForm.email"
                    placeholder="Enter your email"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Remark" prop="remark">
                  <el-input
                    v-model="ruleForm.remark"
                    placeholder="Enter your remark"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-form-item class="submit-box">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >Submit</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="videoDIv" v-show="videoShow">
          <div class="video-box">
            <video
              id="video"
              class="videoDom"
              :src="videoUrl"
              controls
              preload="none"
              :poster="logoUrl"
            ></video>
            <span class="closeVideo" @click="closeVideo()">x</span>
          </div>
        </div>
      </div>
    </article>
    <footer class="footer">
      <p v-if="agentData.brokeName === 'Huttons'">
        The information contained on this website is for general information
        purposes only. Huttons Asia Pte Ltd and its affiliates ("Huttons")
        assumes no responsibility for errors or omissions in the contents of
        this website. In no event shall Huttons be liable for any special,
        direct, indirect, consequential, or incidental damages or any damages
        whatsoever, whether in an action of contract, negligence or other tort,
        arising out of or in connection with the use of the information provided
        herein. Huttons reserves the right to make additions, deletions, or
        modification to the contents of this website at any time without prior
        notice.
      </p>
      <p v-else-if="agentData.brokeName === 'EcoProp+'">
        The use of EcoProp+ and all associated products and features shall be
        subject to the standard terms of use (
        <a href="https://www.ecoprop.com/terms-of-use" target="_blank"
          >https://www.ecoprop.com/terms-of-use</a
        >
        ), terms of sale (<a
          href="https://www.ecoprop.com/terms-of-sale"
          target="_blank"
          >https://www.ecoprop.com/terms-of-sale</a
        >) and privacy policy (<a
          href="https://www.ecoprop.com/privacy-policy"
          target="_blank"
          >https://www.ecoprop.com/privacy-policy</a
        >).
      </p>
      <p v-else>
        The information contained on this website is for general information
        purposes only. Mixgo Pte Ltd (Company of Ecoprop) assumes no
        responsibility for errors or omissions in the contents of this website.
        In no event shall Ecoprop App be liable for any special, direct,
        indirect, consequential, or incidental damages or any damages
        whatsoever, whether in an action of contract, negligence or other tort,
        arising out of or in connection with the use of the information provided
        herein. Ecoprop App reserves the right to make additions, deletions, or
        modification to the contents of this website at any time without prior
        notice.
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      RouteInfo: {},
      agentData: {},
      calcUrl: "",
      img_url: "https://img.singmap.com",
      detailsInfo: {},
      statisticsList: [],
      map: null,
      sitePlanImg: [],
      ElevationChartImgList: [],
      ElevationChartImg: [],
      sitePlanImgList: [],
      unitData: [],
      unitDataList: [],
      UnitTypeData: [],
      UnitType: "",
      Total: 0,
      active: false,
      activeText: "All Plans",
      MediaData: [],
      videoUrl: "",
      logoUrl: "",
      videoShow: false,
      ruleForm: {
        name: "",
        phone: "",
        email: "",
        remark: ""
      },
      rules: {
        name: [{ required: true, message: "Enter your name", trigger: "blur" }],
        phone: [
          {
            required: true,
            message: "Enter your mobile number",
            trigger: "change"
          }
        ],
        email: [
          { required: true, message: "Enter your email", trigger: "change" },
          {
            type: "email",
            message: "Enter your email",
            trigger: ["blur", "change"]
          }
        ]
      },
      navgatorIndex: "",
      listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
      listBox: [
        "Description",
        "Gallery",
        "SiteFloorPlan",
        "Elevation",
        "Facilities",
        "Calculator",
        "Register"
      ],
      service: null,
      infowindow: null,
      nearbyList: [],
      backgroundImage: `url(${require("@/assets/img/404.png")})`,
      projectSet: null,
      img_suffix: "",
      defaultImgResize:
        "?x-oss-process=image/auto-orient,1/interlace,1/resize,p_70/quality,q_100"
    };
  },
  created() {
    const head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.rel = "canonical";
    link.href = `https://www.ecoprop.com/projectdetail/${this.$route.params.projectName.replaceAll(
      " ",
      "-"
    )}`;
    console.log(link);
    head.appendChild(link);
  },
  mounted() {
    // this.RouteInfo = this.$route.query;
    console.log(this.$route.query);
    console.log("newShareInfo");
    this.getShareParams();
    this.querySysConfig();
    // this.setGoogleMap()
    window.addEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // if(scrollTop>=80){
        //   document.querySelector(".nav-wrap").style.position = 'fixed'
        // }else if(scrollTop<80){
        //   document.querySelector(".nav-wrap").style.position = ''
        // }
        this.scrollToTop();
      },
      true
    );
  },
  destroyed() {
    window.removeEventListener(
      "scroll",
      () => {
        // 页面滚动停止100毫秒后才会执行下面的函数。
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // if(scrollTop>=80){
        //   document.querySelector(".nav-wrap").style.position = 'fixed'
        // }else if(scrollTop<80){
        //   document.querySelector(".nav-wrap").style.position = ''
        // }
        this.scrollToTop();
      },
      true
    );
  },
  computed: {
    whatsapp() {
      let num = "";
      if (this.agentData.mobile) {
        num = parseFloat(this.agentData.mobile.replace(/[^0-9]/gi, ""));
      }
      return num;
    }
  },
  methods: {
    toLink() {
      window.open(
        `https://maps.google.com/maps?q=${this.detailsInfo.galleryLatitude},${
          this.detailsInfo.galleryLongitude
        }`
      );
    },
    getShareParams() {
      let param = this.$route.params;
      this.$Post(this.$api.getShareParams, param).then(res => {
        if (res.code === "0") {
          this.RouteInfo = res.datas;
          this.getEmailSetting();
          this.queryProjectInfo();
          this.unitTypeReport();
          this.querySitePlanImg();
          this.queryUnitType();
          this.queryProjectMedia();
        }
      });
    },
    initMap(project, gallery) {
      let self = this;
      let pyrmont = new google.maps.LatLng(project.lat, project.lng);
      this.map = new google.maps.Map(document.getElementById("avenir-map"), {
        center: project,
        zoom: 18
      });
      this.service = new google.maps.places.PlacesService(this.map);
      self.infowindow = new google.maps.InfoWindow();

      // let image = ""
      let marker = new google.maps.Marker({
        position: project,
        map: self.map,
        animation: google.maps.Animation.DROP
        // icon: image,
      });
      let marker1 = new google.maps.Marker({
        position: gallery,
        map: self.map,
        animation: google.maps.Animation.DROP
        // icon: image,
      });
    },
    getEmailSetting() {
      let self = this;
      this.$Get(this.$api.getEmailSetting, {
        agentId: self.RouteInfo.agentId
      }).then(res => {
        if (res.code == 0) {
          this.calcUrl = res.datas.calcUrl;
          this.agentData = res.datas;
          if (this.agentData.brokeName === "Huttons") {
            document.getElementById("wrap").className = "themeHuttons";
          } else {
            document.getElementById("wrap").className = "themeEcoprop";
          }
          this.agentData.signature = this.agentData.signature
            .split("\n")
            .join("<br>");
        }
      });
    },

    querySysConfig() {
      this.$Get(this.$api.querySysConfig, {}).then(res => {
        if (res.code == 0) {
          this.img_url = res.datas.img_url;
          this.img_suffix = res.datas["img_resize_other_app"];
        }
      });
    },
    queryProjectInfo() {
      let self = this;
      this.$Get(this.$api.queryProjectInfo, self.RouteInfo).then(res => {
        if (res.code == 0) {
          self.detailsInfo = res.datas;
          window.document.title = self.detailsInfo.projectName;
          if (res.datas.description)
            self.detailsInfo.description = Base64.decode(res.datas.description);
          if (res.datas.facilities)
            self.detailsInfo.facilities = Base64.decode(res.datas.facilities);
          if (res.datas.nearbyAmenities)
            self.detailsInfo.nearbyAmenities = Base64.decode(
              res.datas.nearbyAmenities
            );
          if (res.datas.facilitiesMap)
            self.nearbyList = JSON.parse(res.datas.facilitiesMap);
          // self.initMap({
          //   lat: Number(self.detailsInfo.latitude),
          //   lng: Number(self.detailsInfo.longitude)
          // }, {
          //   lat: Number(self.detailsInfo.galleryLatitude),
          //   lng: Number(self.detailsInfo.galleryLongitude)
          // });
          // this.$GetFn('https://maps.googleapis.com/maps/api/place/nearbysearch/json', data)
          // .then(res=>{
          //   console.log(res)
          // })
        }
      });
    },
    getFalities() {},
    async unitTypeReport() {
      const projectSetRes = await this.$Get(this.$api.getProjectSetById, {
        projectId: this.RouteInfo.projectId
      });
      if (projectSetRes.code === "0") {
        this.projectSet = projectSetRes.datas;
      }

      const res = await this.$Get(this.$api.unitTypeReport, {
        projectId: this.RouteInfo.projectId,
        agentId: this.RouteInfo.agentId
      });
      if (res.code == 0) {
        this.statisticsList = res.datas;
      }
    },
    setGoogleMap() {
      let head = document.head || document.getElementsByTagName("head")[0];
      let scriptDiv = document.createElement("script"); //  AIzaSyAxuq9fNMvpfLt8gwUa1o9djUYr3XwIw8I
      scriptDiv.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyBFhANESE0lhBp-tSPbOy8FI6FfIiuPR0s&libraries=places";
      head.appendChild(scriptDiv);
    },
    querySitePlanImg() {
      this.$Post(this.$api.querySitePlanImg, this.RouteInfo).then(res => {
        if (res.code == 0) {
          this.ElevationChartImg = [];
          this.sitePlanImg = [];
          let ElevationChartImgList = [];
          let sitePlanImgList = [];
          res.datas.forEach(element => {
            if (element.sitePlanName == "Elevation Chart") {
              this.ElevationChartImg.push(element);
              ElevationChartImgList.push(this.img_url + element.img);
            } else {
              this.sitePlanImg.push(element);
              sitePlanImgList.push(this.img_url + element.img);
            }
          });
          this.ElevationChartImgList = ElevationChartImgList;
          this.sitePlanImgList = sitePlanImgList;
        }
      });
    },
    queryUnitType() {
      let data = {
        projectId: this.RouteInfo.projectId,
        pageNo: 1,
        pageSize: 9999
      };
      this.$Post(this.$api.queryUnitType, data).then(res => {
        if (res.code == 0) {
          if (res.datas.length) {
            this.UnitTypeData = res.datas.map(i => {
              return {
                text: i,
                value: i
              };
            });
            this.UnitTypeData.unshift({
              text: "All Plans",
              value: ""
            });
            this.UnitType = this.UnitTypeData[0].value;
            this.menuFn(this.UnitType);
          }
        }
      });
    },
    menuFn(val) {
      let data = {
        type: val,
        projectId: this.RouteInfo.projectId,
        pageNo: 1,
        pageSize: 9999
      };
      if (val === "All Plans") {
        data.type = "";
      }
      this.$Post(this.$api.queryFloorPlansByType, data, true).then(res => {
        if (res.code == 0) {
          this.Total = res.datas.count;
          this.unitData = res.datas.lists;
          let unitDataList = [];
          res.datas.lists.forEach(ele => {
            unitDataList.push(this.img_url + ele.img);
          });
          this.unitDataList = unitDataList;
        }
      });
    },
    showDropdown() {
      this.active = !this.active;
    },
    selectUnitType(type) {
      this.activeText = type;
      this.active = false;
      this.menuFn(type);
    },
    queryProjectMedia() {
      this.$Post(this.$api.queryProjectMedia, this.RouteInfo, true).then(
        res => {
          if (res.code == 0) {
            this.MediaData = res.datas;
            let imgList = [];
            this.MediaData.img.forEach(ele => {
              imgList.push(this.img_url + ele.url);
            });
            this.imgList = imgList;
            console.log(this.imgList);
          }
        }
      );
    },
    goFileLink(item) {
      window.open(item.link);
    },
    gotoVideo(item) {
      let video = document.getElementById("video");
      if (item.url.includes("https")) {
        window.open(item.url);
      } else {
        this.videoUrl = this.img_url + item.url;
        this.logoUrl = this.img_url + item.logoUrl;
        this.videoShow = true;
        video.load();
      }
    },
    closeVideo() {
      let videoElement = document.getElementById("video");
      videoElement.pause();
      this.videoShow = false;
    },
    gotoCalculate() {
      window.open(this.calcUrl);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            ...this.RouteInfo
          };
          this.$Post(this.$api.sendEmailToAgent, data, true).then(res => {
            if (res.code == 0) {
              this.$dialog
                .alert({
                  title: "Succeed",
                  message:
                    "Information submitted successfully, we will contact you as soon as possible!",
                  confirmButtonText: "OK"
                })
                .then(() => {});
            } else {
              this.$dialog
                .alert({
                  title: "Error",
                  message:
                    "Information submission failed, the server is busy, please submit later!",
                  confirmButtonText: "OK"
                })
                .then(() => {});
            }
          });
        } else {
          return false;
        }
      });
    },
    // 点击导航菜单，页面滚动到指定位置
    toScroll(id) {
      this.navgatorIndex = id;

      // this.$el.querySelector(`#${id}`).scrollIntoView({
      //   behavior: "smooth",  // 平滑过渡
      //   block:    "start"  // 上边框与视窗顶部平齐。默认值
      // });
      var PageId = document.querySelector(`#${id}`);
      window.scrollTo({
        top: PageId.offsetTop - 200,
        behavior: "smooth"
      });
      // console.log(document.getElementById(`${id}`).offsetTop)
      // document.documentElement.scrollTop = documnet.getElementById(`${id}`).offsetTop
      this.listBoxState = false;
      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        (window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop) + 180;

      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.listBox.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop =
            document.getElementById(`${v}`) &&
            document.getElementById(`${v}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight =
            document.getElementById(`${v}`) &&
            document.getElementById(`${v}`).scrollHeight;

          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.navgatorIndex = v;
          }
        });
      }
    }
    // toScroll(item){
    //   let scrollToContainer = document.querySelector(item)
    //   let scrollBody = document.querySelector("#wrap")
    //   console.log(scrollToContainer.offsetTop - scrollBody.offsetTop)
    //   scrollBody.animate({
    //       scrollTop: scrollToContainer.offsetTop - scrollBody.offsetTop
    //     }, 2000);//2秒滑动到指定位置
    //   }
  }
};
</script>

<style lang="less" scoped>
.themeHuttons {
  .theme(#041e42, #041e42);
}
.themeEcoprop {
  .theme(#0f206c, #0f206c);
}

.main {
  width: 1200px;
  margin: 0px auto;
}
p,
h1,
h2 {
  margin: 0;
  padding: 0;
}
.theme(@backcolor:#0f206c,@fcolor:#0f206c) {
  color: #000;
  .agent-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: #fff;
    z-index: 100;
    .main {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo-box {
        display: flex;
        align-items: center;
        .broke-logo {
          width: 70px;
          height: 70px;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          margin-right: 10px;
        }
      }
      .agent-info {
        color: #666;
        display: flex;
        align-items: center;
        .agent-headshot {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: 0 0;
        }
        .agent-name {
          margin-left: 10px;
          font-weight: 600;
        }
        .agent-mobile {
          margin-left: 10px;
          cursor: pointer;
          display: flex;
          align-items: center;
          a {
            color: #666;
          }
          .mobile-img {
            margin-left: 10px;
            width: 20px;
            margin-right: 5px;
            height: 20px;
            background: url(../assets/img/mobile@2x.png) no-repeat center;
            background-size: cover;
          }
          .email-img {
            width: 20px;
            margin-left: 10px;
            height: 20px;
            margin-right: 5px;
            background: url(../assets/img/email@2x.png) no-repeat center;
            background-size: cover;
          }
          .whatsapp-img {
            margin-left: 10px;
            width: 20px;
            height: 20px;
            margin-right: 5px;
            background: url(../assets/img/whatsapp@2x.png) no-repeat center;
            background-size: cover;
          }
        }
        .agent-mobile:hover,
        .agent-mobile:active {
          .mobile-img {
            background-image: url(../assets/img/mobiled@2x.png);
          }
          a {
            color: @fcolor;
          }
          .email-img {
            background-image: url(../assets/img/emailed@2x.png);
          }
          .whatsapp-img {
            background-image: url(../assets/img/whatsappd@2x.png);
          }
        }
        .agentHuttons:hover,
        .agentHuttons:active {
          .mobile-img {
            background-image: url(../assets/img/mobile@2x.png);
          }
          a {
            color: @fcolor;
          }
          .email-img {
            background-image: url(../assets/img/email@2x.png);
          }
          .whatsapp-img {
            background-image: url(../assets/img/whatsapp@2x.png);
          }
        }
        .agent-mobile {
          margin-left: 10px;
          cursor: pointer;
          display: flex;
          align-items: center;
          a {
            color: #666;
          }
        }
      }
    }
  }
  .nav-wrap {
    background: @backcolor;
    height: 100px;
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 100;
    box-shadow: 0px 1px 15px 0px rgba(20, 15, 38, 0.1);
    .main {
      height: 100px;
      .menu-list {
        display: flex;
        justify-content: space-around;
        .menu-item {
          flex: 1;
          text-align: center;
          height: 100px;
          color: #fff;
          padding: 0 7px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .active,
        .menu-item:hover {
          background: #fff;
          color: @fcolor;
          font-weight: 600;
        }
      }
    }
  }
  .banner {
    margin-top: 180px;
    width: 100%;
    height: 800px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    .project-name {
      text-align: center;
      height: 88px;
      margin-top: 73px;
      font-size: 72px;
      font-family: Montserrat-Black, Montserrat;
      font-weight: 900;
      color: #ffffff;
      line-height: 88px;
    }
  }
  .content-box {
    padding-top: 100px;
    background: #fdfcfb;
    .main {
      .description-box {
        margin-top: 73px;
      }
      .client-box {
        background: #fff;
        padding: 50px 40px;
        .client-title {
          margin-bottom: 30px;
        }
        .client-content {
          margin-bottom: 80px;
        }
        .project-name {
          margin-bottom: 30px;
        }
      }
      .facilities-box {
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        .nearby-list-box {
          .nearby-list-name {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .nearby-list-mark {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: @backcolor;
              border-radius: 1px;
              margin-right: 5px;
            }
            .nearby-list-text {
              font-size: 18px;
              font-weight: 600;
            }
          }
          .nearby-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .nearby-item {
              padding-right: 30px;
              margin-bottom: 20px;
              font-size: 16px;
              font-family: Montserrat-Medium, Montserrat;
              font-weight: 500;
              color: #333333;
              line-height: 19px;
            }
          }
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
          .nearby-list-box {
            margin-left: 20px;
          }
        }
      }
      .available-box {
        margin-top: 80px;
        .table-wrap {
          margin-top: 30px;
          padding: 50px 60px 50px 30px;
          background: #fff;
          .table-box {
            width: 100%;

            tr {
              .align-left {
                text-align: left;
              }
              .align-center {
                text-align: center;
              }
              .align-right {
                text-align: right;
              }
            }
            thead {
              tr {
                th {
                  height: 40px;
                }
              }
            }
            tbody {
              tr {
                td {
                  height: 30px;
                }
                .border-right {
                  border-right: 1px solid #eeeeee;
                }
              }
            }
          }
          .callMe {
            margin-top: 10px;
            height: 11px;
            font-size: 12px;
            font-weight: bold;
            color: @fcolor;
            line-height: 11px;
          }
        }
      }
      .avenir-box {
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        .map-box {
          background: #fff;
          // height: 529px;
          display: flex;
          .map-info {
            flex: 1;
            padding: 36px 30px 0 30px;
            p {
              word-wrap: break-word;
              margin: 10px 0;
            }
          }
          #avenir-map {
            width: 800px;
            height: 529px;
          }
          .img-box {
            img {
              height: 300px;
            }
          }
        }
      }

      .calculator-wrap {
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
        }
        /deep/.calculator-box {
          display: flex;
          justify-content: center;
          .el-button {
            width: 555px;
            height: 70px;
            border-radius: 10px;
            color: @fcolor;
            font-size: 20px;
            font-weight: 600;
            border: 2px solid @backcolor;
          }
        }
      }

      .site-plan-box,
      .elevation-chart-box {
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
        }
        /deep/.img-box {
          max-height: 1815px;
          overflow-y: auto;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .el-image {
            width: 585px;
            height: 418px;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-top {
            margin-top: 30px;
          }
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          .img-box {
            justify-content: center;
            .margin-top {
              margin-top: 0px;
            }
            .margin-top-ipad {
              margin-top: 30px;
            }
          }
        }
      }
      .floor-plans-box {
        max-height: 1523px;
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
        }
        .floor-content {
          position: relative;
          .popup-top {
            height: 60px;
            background: #fff;
            display: flex;
            border-bottom: 1px solid #eeeeee;
            align-items: center;
            .popup-selected {
              flex: 1;
              display: flex;
              justify-content: center;
              .popup-text {
              }
            }
            .total {
              flex: 1;
              text-align: center;
            }
          }
          .dropdown-mark {
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            position: absolute;
            top: 61px;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            .dropdown-box {
              position: absolute;
              left: 0;
              right: 0;
              z-index: 5;
              background: #fff;
              p {
                height: 40px;
                cursor: pointer;
                line-height: 40px;
                text-indent: 60px;
              }
              p.active,
              p:hover {
                color: #1989fa;
              }
            }
          }
          .plans-box {
            max-height: 1374px;
            overflow-y: auto;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 30px;
            .el-image {
              width: 585px;
              height: 418px;
              border-radius: 15px;
              .el-error {
                width: 100%;
                height: 100%;
                display: flex;
                vertical-align: middle;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                color: #c0c4cc;
                background: #f5f7fa;
              }
            }
            .margin-top {
              margin-top: 30px;
            }
          } /*修改滚动条样式*/
          .plans-box::-webkit-scrollbar {
            width: 10px;
            height: 10px;
            /**/
          }
          .plans-box::-webkit-scrollbar-track {
            background: rgb(239, 239, 239);
            border-radius: 2px;
          }
          .plans-box::-webkit-scrollbar-thumb {
            background: #bfbfbf;
            border-radius: 10px;
          }
          .plans-box::-webkit-scrollbar-thumb:hover {
            background: #333;
          }
          .plans-box::-webkit-scrollbar-corner {
            background: #179a16;
          }
          @media screen and (max-width: 1200px) and (min-width: 767px) {
            .plans-box {
              justify-content: center;
            }
          }
        }
      }

      .gallery-box {
        h1 {
          margin-top: 80px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-top: 80px;
            margin-left: 20px;
          }
        }
        .img-box {
          padding: 30px;
          overflow-x: auto;
          width: auto;
          white-space: nowrap;
          .el-image {
            width: 380px;
            height: 300px;
            border-radius: 15px;
            .el-error {
              width: 100%;
              height: 100%;
              display: flex;
              vertical-align: middle;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #c0c4cc;
              background: #f5f7fa;
            }
          }
          .margin-left {
            margin-left: 30px;
          }
        } /*修改滚动条样式*/
        .img-box::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .img-box::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .img-box::-webkit-scrollbar-thumb {
          background: #bfbfbf;
          border-radius: 10px;
        }
        .img-box::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .img-box::-webkit-scrollbar-corner {
          background: #179a16;
        }
      }

      .virtual-wrap {
        h1 {
          margin-top: 80px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-top: 80px;
            margin-left: 20px;
          }
        }
        .virtual-box {
          max-height: 1815px;
          overflow: auto;
          margin-top: 30px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .img-box {
            position: relative;
            img {
              width: 585px;
              height: 418px;
              border-radius: 15px;
            }
            .LinkBtn {
              padding: 10px;
              border-radius: 50%;
              background: rgba(0, 0, 0, 0.5);
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -65px;
              margin-left: -65px;
              cursor: pointer;
              .iconSpn {
                width: 130px;
                height: 130px;
                display: inline-block;
                background: url("../assets/img/virtual.png") no-repeat 0 0;
                background-size: 100% 100%;
              }
              .VideoBtn {
                width: 130px;
                height: 130px;
                display: inline-block;
                background: url("../assets/img/video.png") no-repeat 0 0;
                background-size: 100% 100%;
              }
            }
          }
          .margin-top {
            margin-top: 30px;
          }
        } /*修改滚动条样式*/
        .virtual-box::-webkit-scrollbar {
          width: 10px;
          height: 10px;
          /**/
        }
        .virtual-box::-webkit-scrollbar-track {
          background: rgb(239, 239, 239);
          border-radius: 2px;
        }
        .virtual-box::-webkit-scrollbar-thumb {
          background: #bfbfbf;
          border-radius: 10px;
        }
        .virtual-box::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
        .virtual-box::-webkit-scrollbar-corner {
          background: #179a16;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          .virtual-box {
            justify-content: center;
          }
        }
      }

      .showflat-box {
        overflow: hidden;
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
        }
        .showflat-bontent {
          font-weight: 600;
          color: #333;
          p {
            margin: 15px 0px;
            .phone {
              color: @backcolor;
            }
          }
        }
      }
      .register-box {
        margin-top: 80px;
        h1 {
          margin-bottom: 30px;
        }
        @media screen and (max-width: 1200px) and (min-width: 767px) {
          h1 {
            margin-bottom: 30px;
            margin-left: 20px;
          }
        }
        /deep/.form-box {
          height: 516px;
          padding: 50px 30px;
          background: #fff;
          font-weight: 600;
          p {
            margin-bottom: 30px;
          }
          .el-form {
            .el-row {
              display: flex;
              justify-content: space-between;
              .el-form-item {
                width: 555px;
                .el-form-item__label {
                  font-weight: 600;
                  color: #333;
                  font-size: 16px;
                }
                .el-form-item__content {
                  .el-input {
                    .el-input__inner {
                      background: #f7f7f7;
                      border-radius: 10px;
                      height: 50px;
                      border-color: #fff;
                    }
                  }
                }
              }
            }
            .submit-box {
              display: flex;
              margin-top: 50px;
              justify-content: center;
              .el-button {
                width: 555px;
                height: 70px;
                font-size: 20px;
                border-radius: 10px;
                background: #fff;
                color: @backcolor;
                font-weight: 600;
                border: 2px solid @backcolor;
              }
            }
          }
        }
      }
    }
  }
  .videoDIv {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 101;
    background: rgba(0, 0, 0, 0.5);
    .video-box {
      position: relative;
      #video {
        max-height: 600px;
      }
      .closeVideo {
        position: absolute;
        top: 5px;
        right: 10px;
        color: #fff;
        cursor: pointer;
        font-size: 30px;
      }
    }
  }
  .footer {
    background: #000;
    overflow: hidden;
    p {
      width: 1200px;
      color: #fff;
      margin: 20px auto;
      a {
        color: rgba(255, 255, 255, 0.7);
      }
    }
    @media screen and (max-width: 1200px) and (min-width: 767px) {
      p {
        width: 100%;
        padding: 20px;
        margin: 0 auto;
      }
    }
  }

  @media screen and (max-width: 1200px) and (min-width: 767px) {
    .main {
      width: 100%;
      margin: 0px auto;
    }
  }
}
</style>

<style>
.nearby-content img {
  width: 100% !important;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/page/newShareInfo.vue